import React from 'react';

import styles from './TitleDuoTone.module.scss';

const TITLE_ID = 'title-test-id';

interface TitleDuoToneProps {
  text: string;
  textToChangeColor: string;
  color?: string;
  withWrapper?: boolean;
}

function colorizeText({ text, textToChangeColor, color }: TitleDuoToneProps) {
  const startIndex = text.indexOf(textToChangeColor);
  const newString = text.substring(0, startIndex);
  const lastString = text.replace(`${newString}${textToChangeColor}`, '');

  return (
    // This allow testing library to find the element by the text inside the h3 otherwise it will fail
    <h3 data-testid={TITLE_ID} className={styles.title}>
      {newString}
      <span style={{ color }}>{textToChangeColor}</span>
      {lastString}
    </h3>
  );
}

const TitleDuoTone = ({
  text,
  textToChangeColor,
  color = '#fb6a66',
  withWrapper = true,
}: TitleDuoToneProps) => {
  const coloredString = colorizeText({ text, textToChangeColor, color });
  return withWrapper ? <div className={styles.wrapper}>{coloredString}</div> : coloredString;
};

export { TITLE_ID };
export type { TitleDuoToneProps };
export default TitleDuoTone;
